import React from 'react';
import './Menu.css';
import logo from '../../assets/renzfoods-logo_transparent.png';

const Menu = () => {
  const spicyIcon = '🌶️';

  return (
    <div className="menu-container">
      <div className="menu-board">
        {/* Header with Menu title */}
        <header className="menu-header">
          <h1 className="menu-title">MENU</h1>
        </header>

        {/* Main Menu Content */}
        <div className="menu-content">
          {/* Left Column - Fish, Inari Bombs, Sides */}
          <div className="menu-left">
            {/* FISH Section */}
            <section className="menu-section">
              <div className="section-header">
                <h2 className="section-title">FISH</h2>
                <span className="section-price">$9.50</span>
              </div>
              <p className="section-note">All items will be weighed out to 8 ounces and above</p>
              
              <div className="menu-item">
                <h3 className="item-title">-HAWAIIAN W/ LIMU</h3>
                <p className="item-description">Classic, Hawaiian staple with chili water and ogo limu</p>
                <p className="item-options">• AHI*</p>
              </div>

              <div className="menu-item">
                <h3 className="item-title">-GOCHUGANG MAYO {spicyIcon}</h3>
                <p className="item-description">Korean twist on spicy mayo. <span className="best-seller">*BEST SELLER*</span></p>
                <p className="item-options">• AHI*/SALMON*</p>
              </div>

              <div className="menu-item">
                <h3 className="item-title">-MISO GLAZE</h3>
                <p className="item-description">Japanese inspired flavor that highlights miso</p>
                <p className="item-options">• AHI*/SALMON*</p>
              </div>
            </section>

            <div className="divider"></div>

            {/* INARI BOMBS Section */}
            <section className="menu-section">
              <div className="menu-item">
                <h3 className="item-title standalone">4PC. INARI BOMBS</h3>
                <p className="item-description">Deep fried tofu cones stuffed with sushi rice and toppings</p>
              </div>

              <div className="menu-item sub-item">
                <div className="item-header-row">
                  <h3 className="item-title">-SPICY TUNA {spicyIcon}</h3>
                  <span className="item-price">$8.00</span>
                </div>
                <p className="item-description sub">Gochugang mayo tuna mix</p>
              </div>

              <div className="menu-item sub-item">
                <div className="item-header-row">
                  <h3 className="item-title">-CALIFORNIA</h3>
                  <span className="item-price">$6.00</span>
                </div>
                <p className="item-description sub">Imitation crab mayo mix</p>
              </div>
            </section>

            <div className="divider"></div>

            {/* SIDES Section */}
            <section className="menu-section">
              <div className="section-header">
                <h2 className="section-title">SIDES</h2>
                <span className="section-price">$2.50</span>
              </div>

              <div className="menu-item">
                <h3 className="item-title">-SPICY GARLIC EDAMAME {spicyIcon}</h3>
                <p className="item-description sub">Marinated soybeans</p>
              </div>

              <div className="menu-item">
                <h3 className="item-title">-WAKAME</h3>
                <p className="item-description sub">Ocean salad</p>
              </div>

              <div className="menu-item">
                <h3 className="item-title">-CUCUMBER SALAD</h3>
                <p className="item-description sub">Japanese style pickles (sunomono)</p>
              </div>
            </section>
          </div>

          {/* Vertical Divider */}
          <div className="vertical-divider"></div>

          {/* Right Column - Spam Musubi, Rice, Footer */}
          <div className="menu-right">
            {/* SPAM MUSUBI Section */}
            <section className="right-section">
              <h2 className="right-section-title">SPAM MUSUBI</h2>
              <p className="right-section-description">Spam and rice wrapped in nori (dry seaweed)</p>
              
              <div className="right-options">
                <div className="right-option">
                  <span className="option-name">REGULAR RICE</span>
                  <span className="option-price">$2.50</span>
                </div>
                <div className="right-option">
                  <span className="option-name">GARLIC FRIED RICE</span>
                  <span className="option-price">$3.50</span>
                </div>
                <div className="right-option">
                  <span className="option-name">KIMCHI FRIED RICE {spicyIcon}</span>
                  <span className="option-price">$4.50</span>
                </div>
              </div>
            </section>

            <div className="divider"></div>

            {/* RICE Section */}
            <section className="right-section">
              <h2 className="right-section-title">RICE</h2>
              <p className="right-section-description">Heaping scoop of rice of choice</p>
              
              <div className="right-options">
                <div className="right-option">
                  <span className="option-name">WHITE RICE</span>
                  <span className="option-price">$0.50</span>
                </div>
                <div className="right-option">
                  <span className="option-name">GARLIC SPAM FRIED RICE</span>
                  <span className="option-price">$4.00</span>
                </div>
                <div className="right-option">
                  <span className="option-name">KIMCHI SPAM FRIED RICE {spicyIcon}</span>
                  <span className="option-price">$5.00</span>
                </div>
              </div>
            </section>

            <div className="divider"></div>

            {/* Footer Section with Logo */}
            <footer className="menu-footer">
              <div className="menu-logo">
                <img src={logo} alt="Renz Grindz" />
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;